/**
 * Contexto e antes→depois de uma linha da trilha — GUPM-335.
 *
 * Só apresentação: quem decide O QUE mudou é `camposAlterados` (domínio).
 */
import { ipDaLinha, rotuloDoCanal, type AuditEntry } from '@/domain/auditoria';
import type { CampoAlterado } from '@/domain/auditoria/descrever-acao';

export function ContextoDaAcao({ entry }: { entry: AuditEntry }) {
  const itens: Array<{ rotulo: string; valor: string | null | undefined }> = [
    { rotulo: 'E-mail', valor: entry.actorEmail },
    { rotulo: 'IP', valor: ipDaLinha(entry) },
    { rotulo: 'Cadeia de proxies', valor: entry.ipCadeia },
    { rotulo: 'Navegador', valor: entry.userAgent },
    { rotulo: 'Canal', valor: entry.canal ? rotuloDoCanal(entry.canal) : null },
    // Só existe em escrita direta no banco; nas demais a linha não aparece.
    ...(entry.conexao ? [{ rotulo: 'Conexão', valor: entry.conexao }] : []),
  ];
  return (
    <div role="group" aria-label="Contexto da ação" className="grid gap-2 sm:grid-cols-3 lg:grid-cols-6">
      {itens.map((i) => (
        <dl key={i.rotulo} className="rounded-md border border-jf-border bg-jf-surface p-2 text-xs">
          <dt className="font-bold text-jf-dim">{i.rotulo}</dt>
          <dd className="text-white break-all mt-0.5">
            {i.valor ?? <span className="italic text-jf-muted">não registrado</span>}
          </dd>
        </dl>
      ))}
    </div>
  );
}

export function TabelaDeAlteracoes({ campos }: { campos: CampoAlterado[] }) {
  return (
    <table aria-label="Alterações" className="w-full text-xs border border-jf-border rounded-md overflow-hidden">
      <thead className="bg-jf-surface2 text-[10px] uppercase tracking-wide text-jf-dim">
        <tr>
          <th className="px-2 py-1 text-left">Campo</th>
          <th className="px-2 py-1 text-left">Antes</th>
          <th className="px-2 py-1 text-left">Depois</th>
        </tr>
      </thead>
      <tbody>
        {campos.map((c) => (
          <tr key={c.campo} className="border-t border-jf-border align-top">
            <td className="px-2 py-1 font-bold text-jf-dim">{c.campo}</td>
            <td className="px-2 py-1 font-mono break-all text-red-300">{c.antes}</td>
            <td className="px-2 py-1 font-mono break-all text-green-300">{c.depois}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
